<div class="preview-button preview-left" (click)="previewLeft()">
    <app-icon class="preview-icon" type="Arrow-left"></app-icon>
    <span>Prev</span>
</div>
<div class="preview-button preview-right" (click)="previewRight()">
    <app-icon class="preview-icon" type="Arrow-right"></app-icon>
    <span>Next</span>
</div>
